import React from 'react';
import { pickZonePhoto } from '../services/gardenApi';

// A single zone thumbnail card for the home grid.
// Shows the zone's best available photo (preferred/default season fallback),
// zone name, and a marker count badge.
export default function ZoneCard({ zone, onClick, preferredSeason }) {
  const { url, season } = pickZonePhoto(zone, preferredSeason);
  const count = Number(zone.marker_count || 0);

  return (
    <button
      onClick={onClick}
      className="group block text-left w-full rounded-2xl overflow-hidden bg-white border border-black/5 shadow-sm active:scale-[0.99] transition"
    >
      <div className="relative aspect-[4/5] bg-garden-primaryLight">
        {url ? (
          <img
            src={url}
            alt={zone.name}
            className="absolute inset-0 w-full h-full object-cover"
            loading="lazy"
          />
        ) : (
          <ZoneCardEmpty />
        )}
        {season && url ? (
          <div className="absolute top-2 left-2 px-2 py-0.5 text-[10px] font-medium bg-white/90 rounded-full text-garden-ink capitalize shadow-sm">
            {season}
          </div>
        ) : null}
        {count > 0 ? (
          <div className="absolute bottom-2 right-2 px-2 py-0.5 text-xs font-semibold bg-garden-primary text-white rounded-full shadow">
            {count} {count === 1 ? 'plant' : 'plants'}
          </div>
        ) : null}
      </div>
      <div className="px-3 py-2">
        <div className="font-semibold text-garden-ink truncate">{zone.name}</div>
        {!url ? (
          <div className="text-xs text-garden-muted">Tap to add a photo</div>
        ) : count === 0 ? (
          <div className="text-xs text-garden-muted">No plants placed yet</div>
        ) : null}
      </div>
    </button>
  );
}

function ZoneCardEmpty() {
  return (
    <div className="absolute inset-0 flex items-center justify-center text-garden-primaryDark">
      <svg width="56" height="56" viewBox="0 0 64 64" fill="none" aria-hidden>
        <path d="M22 48h20l-2 8H24l-2-8Z" fill="currentColor" opacity="0.25" />
        <path d="M20 44h24v4H20z" fill="currentColor" opacity="0.35" />
        <path
          d="M32 40c0-10 6-14 12-14-2 8-6 14-12 14Zm0 0c0-10-6-14-12-14 2 8 6 14 12 14Zm0 0V20"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </svg>
    </div>
  );
}
